import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import { EventHeader } from "./header/EventHeader";
import EventAuthFooter from "@ui/components/Footers/EventAuthFooter";
export const EventLayout = ({ logoPosition }) => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isDrawerOpend, setIsDrawerOpend] = useState(false);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", sx: {
            height: "100dvh",
            position: "relative",
            overflow: "hidden",
        }, children: [_jsx(Box, { sx: {
                    position: "absolute",
                    top: "120px",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    zIndex: 1, // Put it behind the main content
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/main-page.png", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0, // Put it behind everything else
                    backgroundImage: `url('/assets/images/event-bg.png')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                } }), _jsxs(Box, { sx: {
                    width: "100%",
                    overflow: "auto",
                    transition: "padding-left .2s ease-in-out",
                    zIndex: 100,
                    height: "100%",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                }, className: "events__main-content-wrapper", children: [_jsx(EventHeader, { handleDrawer: () => {
                            setIsDrawerOpend(true);
                        }, handleMenu: () => setIsCollapsed(!isCollapsed) }), _jsx(Container, { sx: {
                            [theme.breakpoints.up(1024)]: {
                                mt: 3,
                                pt: 8,
                            },
                            [theme.breakpoints.down(1025)]: {
                                mt: 2,
                                pt: 5,
                            },
                            [theme.breakpoints.down(391)]: {
                                mt: 0,
                                pt: 5,
                            },
                            flex: 1,
                        }, className: "content-container", children: _jsx(Outlet, {}) }), _jsx(EventAuthFooter, { logoPosition: logoPosition })] })] }));
};
